<template>
  <b-form class="registration" @submit="handleFirstName">
    <b-form-group class="registration__input p-3">
      <b-form-input v-model="firstName" @keydown.enter="handleFirstName" type="text" required placeholder="Entrez votre Prénom" />

      <div class="input__error" v-if="!$v.firstName.required">Le champ est requis.</div>
      <div class="input__error" v-if="!$v.firstName.minLength">
        Votre prénom doit avoir au moins {{ $v.firstName.$params.minLength.min }} caractères.
      </div>
      <div class="input__error" v-if="!$v.firstName.maxLength">
        Votre prénom doit avoir un maximum de {{ $v.firstName.$params.maxLength.min }} caractères.
      </div>

      <div class="text-center mt-4">
        <b-button @click="handleFirstName" variant="success">Continuer</b-button>
      </div>
    </b-form-group>
  </b-form>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BButton } from "bootstrap-vue";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  name: "FirstName",
  mixins: [validationMixin],
  components: { BForm, BFormGroup, BFormInput, BButton },
  data: () => ({
    firstName: null,

    errorMessage: null,
    hasSubmitError: false,
  }),
  methods: {
    handleFirstName(e) {
      if (e) e.preventDefault();

      this.$v.$touch();

      if (this.$v.$invalid) return;

      const { firstName } = this;
      this.$emit("success", firstName);
    },
  },
  validations: {
    firstName: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(100),
    },
  },
};
</script>
